export default __webpack_public_path__ + "assets/images/41aae7c227bf214660565c33dbcae04c.png";